(() => {
  let frame = 0;

  const inversePageZoom = () => {
    if (!window.outerWidth || !window.innerWidth) return 1;
    const pageZoom = window.outerWidth / window.innerWidth;
    if (pageZoom < 1.05) return 1;
    return 1 / Math.min(pageZoom, 2.5);
  };

  const sync = () => {
    frame = 0;
    document.documentElement.style.setProperty('--koko-pdp-wish-zoom-scale', String(inversePageZoom()));
  };

  const queueSync = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(sync);
  };

  sync();
  window.addEventListener('resize', queueSync, { passive: true });
  window.visualViewport?.addEventListener('resize', queueSync, { passive: true });
  document.addEventListener('shopify:section:load', queueSync);
})();
